import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-closed-list",
    template: `
        <section-warehouse-order-list [state]="state" [status]="'packed'"
                                      header="Packed orders"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderPackedListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-packed",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
